<div class="wetter_content_container">
  <section class="bericht-text-container">
    <h3 class="bericht-text-sub-label">Vorhersagen</h3>
    <p>{{deutschlandwetterOpenMedia?.vorhersage}}</p>
  </section>
  <section class="bericht-text-container">
    <h3 class="bericht-text-sub-label">Wetterlage</h3>
    <p>{{deutschlandwetterOpenMedia?.wetterlage}}</p>
  </section>
  <section class="bericht-text-container">
    <h3 class="bericht-text-sub-label">Aussichten</h3>
    <p>{{deutschlandwetterOpenMedia?.aussichten}}</p>
  </section>
</div>
